document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".nw-image-slider");

  sliders.forEach((slider) => {
    const sliderCells = slider.querySelectorAll(".nw-slider-cell");
    if (sliderCells.length > 5) {
      // Only initialise Flickity if more than 5 cells
      new Flickity(slider, {
        cellAlign: "left",
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: 5,
        responsive: {
          768: {
            groupCells: 3, // Show 3 slides on mobile
          },
        },
      });
    } else {
      // Remove navigation if fewer than 5 images
      slider.querySelectorAll(".flickity-prev-next-button").forEach((button) => {
        button.style.display = "none";
      });
    }
  });
});